import type { SVGProps } from 'react';
const SvgCompress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#compress_svg__a)">
      <path d="M8 19h3v3h2v-3h3l-4-4-4 4Zm8-15h-3V1h-2v3H8l4 4 4-4ZM4 9v2h16V9H4ZM4 12h16v2H4v-2Z" />
    </g>
    <defs>
      <clipPath id="compress_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCompress;
